import { Wizard } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { StepLayout } from '../StepLayout'
import { StepChoiceChips } from '../StepChoiceChips'
import { StepActions } from '../StepActions'

export const BraAge = () => {
  const { t } = useTranslation()
  return (
    <Wizard.Step>
      <StepLayout
        title={t('fitting_room.bra_age.title')}
        subtitle={t('fitting_room.bra_age.subtitle')}
      >
        <StepChoiceChips
          name="braAge"
          options={['0-6', '6-12', '12-18', '18+'].map((value) => ({
            value,
            label: `${value.split('-').join(' - ')} ${t('date.month', {
              count: 0,
            })}`,
          }))}
        />
        <StepActions next={false} />
      </StepLayout>
    </Wizard.Step>
  )
}
